export const careersData = {
    fullTimeRoles: [],
    internshipRoles: [],
    benefits: [
        {
            icon: "flaticon-team",
            title: "Professional Growth",
            description: "Continuous learning opportunities and career development programs"
        },
        {
            icon: "flaticon-healthcare",
            title: "Health & Wellness",
            description: "Comprehensive health insurance and wellness programs"
        },
        {
            icon: "flaticon-time",
            title: "Work-Life Balance",
            description: "Flexible working hours and remote work options"
        },
        {
            icon: "flaticon-trophy",
            title: "Competitive Compensation",
            description: "Market-leading salaries and performance bonuses"
        },
        {
            icon: "flaticon-innovation",
            title: "Innovation Culture",
            description: "Work with cutting-edge technologies and innovative projects"
        },
        {
            icon: "flaticon-community",
            title: "Collaborative Environment",
            description: "Supportive team culture and collaborative workspace"
        }
    ],
    applicationProcess: [
        {
            step: 1,
            title: "Submit Application",
            description: "Send your CV and cover letter to careers@infotraceanalytics.com"
        },
        {
            step: 2,
            title: "Initial Screening",
            description: "Our HR team will review your application and contact shortlisted candidates"
        },
        {
            step: 3,
            title: "Technical Assessment",
            description: "Complete a technical assessment relevant to the position"
        },
        {
            step: 4,
            title: "Interviews",
            description: "Participate in interviews with team members and management"
        },
        {
            step: 5,
            title: "Offer & Onboarding",
            description: "Receive an offer and begin your journey with Infotrace Analytics"
        }
    ]
};
